module.exports = __webpack_public_path__ + "img/dcc_logo.127d7269.png";